export const getLogoData = (modelInfo) => {
  const {
    assetsBrand,
    brandVariant,
    isFleet,
    isFamilyFirst,
    isFamilyFirstCA,
    language,
    isCanada,
    uiPath,
  } = modelInfo;

  const path = `${uiPath}/assets/images/logos/`;

  if (isFleet) {
    const name = 'fleet';
    return {
      logoUrl: `${path}${name}.svg`,
    };
  }

  if (brandVariant === 'cvo') {
    const name = 'cvo';
    return {
      logoUrl: `${path}${name}.png`,
    };
  }

  if (isFamilyFirstCA && isCanada) {
    const name = language === 'fr' ? 'ff-CA-fr' : 'ff-CA';
    const HORIZONTAL_IMAGE_WIDTHS = {
      en: 675,
      fr: 1202,
    };
    const breakpoint = HORIZONTAL_IMAGE_WIDTHS[language];
    return {
      logoUrl: `${path}${name}.svg`,
      logoBreakpoint: breakpoint,
      lowDpiLogoUrl: `${path}${name}.png`,
      highDpiLogoUrl: `${path}${name}-retina.png 2x`,
      lowDpiHorizontalLogoUrl: `${path}${name}-horizontal.png`,
      highDpiHorizontalLogoUrl: `${path}${name}-horizontal-retina.png 2x`,
    };
  }

  if (isFamilyFirst) {
    const url = `${path}${brandVariant}.svg`;
    return {
      logoUrl: `${path}${brandVariant}.svg`,
      logoBreakpoint: 0,
      lowDpiLogoUrl: url,
      highDpiLogoUrl: url,
      lowDpiHorizontalLogoUrl: url,
      highDpiHorizontalLogoUrl: url,
    };
  }

  const url = `${path}${assetsBrand}.svg`;
  return {
    logoUrl: url,
  };
};
